import { useCallback } from 'react';
import { moldService } from '../services/api';
import { useMoldContext } from '../context/MoldContext';
import { Mold, Task } from '../types/mold';

export const useMolds = () => {
  const { state, dispatch } = useMoldContext();

  const fetchMolds = useCallback(async () => {
    try {
      dispatch({ type: 'FETCH_MOLDS_START' });
      const response = await moldService.getMolds();
      dispatch({ type: 'FETCH_MOLDS_SUCCESS', payload: response.data });
    } catch (error) {
      dispatch({
        type: 'FETCH_MOLDS_ERROR',
        payload: error instanceof Error ? error.message : 'An error occurred',
      });
    }
  }, [dispatch]);

  const fetchMoldsWithMoldOrder = useCallback(async () => {
    try {
      dispatch({ type: 'FETCH_MOLDS_START' });
      const response = await moldService.getMolds({ withOpenOrder: true });
      dispatch({ type: 'FETCH_MOLDS_SUCCESS', payload: response.data });
    } catch (error) {
      dispatch({
        type: 'FETCH_MOLDS_ERROR',
        payload: error instanceof Error ? error.message : 'An error occurred',
      });
    }
  }, [dispatch]);

  const updateMoldStatus = useCallback(
    async (moldId: string, status: Mold['status']) => {
      try {
        const response = await moldService.updateMold(moldId, { status });
        dispatch({ type: 'UPDATE_MOLD', payload: response.data });
      } catch (error) {
        console.error('Error updating mold status:', error);
      }
    },
    [dispatch],
  );

  const updateTaskStatus = useCallback(
    async (taskId: string, status: Task['status']) => {
      try {
        await moldService.updateTaskStatus(taskId, status);
        dispatch({
          type: 'UPDATE_TASK_STATUS',
          payload: { id: taskId, status },
        });
      } catch (error) {
        console.error('Error updating task status:', error);
      }
    },
    [dispatch],
  );

  return {
    molds: state.molds,
    loading: state.loading,
    error: state.error,
    fetchMolds,
    fetchMoldsWithMoldOrder,
    updateMoldStatus,
    updateTaskStatus,
  };
};
